const findBranch = (data, collectionSection) => {
    const allSections = collectionSection.map(section => section.id);
    const options = collectionSection[0].questions[0]?.options;
    if (typeof options === 'undefined') {
        return allSections;
    } else {
        if (!options) return [];

        const selectedBranchValue = data.sections.filter(s => s.id === allSections[0])[0]
            ?.questions[0].value;
        const selectedOption = collectionSection[0].questions[0].options.filter(
            x => x.key === selectedBranchValue
        );
        const checkIfBranchExist = selectedOption[0]?.branching?.section_ids;
        if (checkIfBranchExist) {
            const optionExcludeBranching = options.filter(x => x.key !== selectedBranchValue);
            const excludeBranching = optionExcludeBranching.map(option => {
                const branch = option.branching?.section_ids ?? [];
                return branch;
            });
            const branchesToValidate = allSections.filter(x => {
                return !excludeBranching[0].includes(x);
            });

            return branchesToValidate;
        } else {
            return allSections;
        }
    }
};

exports.findBranch = findBranch;
